/**
 * Where the top bar's Add Work Order starts: the location on screen. That is
 * a location's Departments page, its work orders, its inventory or its
 * customers. Anywhere
 * else (Executive, My Work, Reports, Help) there is no location on screen, so
 * the form asks which one — unless the person has only one, which the form
 * picks itself (settleLocationChoice).
 */
export interface QuickCreateScope {
  currentView: string;
  /** The person sees the Executive dashboard (it replaces Departments on the plain dashboard view). */
  showExecutiveDashboard: boolean;
  canViewLocationDashboard: boolean;
  /** The location the address or the remembered selection names. */
  locationId: string | null | undefined;
}

const LOCATION_VIEWS = new Set(['workorders', 'inventory', 'customers']);

export function quickCreateLocationId(scope: QuickCreateScope): string | undefined {
  const { currentView, showExecutiveDashboard, canViewLocationDashboard, locationId } = scope;
  const onDepartments =
    canViewLocationDashboard && (currentView === 'dashboard:location' || (currentView === 'dashboard' && !showExecutiveDashboard));
  const usable = locationId && locationId.toLowerCase() !== 'all' ? locationId : undefined;
  return onDepartments || LOCATION_VIEWS.has(currentView) ? usable : undefined;
}
